import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const infoTechApi = {
    addRoleToProfile: (id, item) => {
        const url = `api/admin/v1/jalaprofiles/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    createAccount: (item) => {
        const url = `api/admin/v1/jalacounts`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    createFoodAsMedicineAccount: (item) => {
        const url = `api/admin/v1/fam/account`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    createEmployeeBox: (item) => {
        const url = `api/admin/v1/discountff`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    createKnowledgeBase: (item) => {
        const url = `api/admin/v1/itsKnowledge`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    createPicker: (item) => {
        const url = `api/warehouse/v1/pickers`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    createPickerForJalapenoAccount: (formData) => {
        const url = `api/admin/v1/jalacounts/picker`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(formData),
        });
    },
    createProfile: (item) => {
        const url = `api/admin/v1/jalaprofiles`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    downloadBadge: async (pickerID) => {
        const filename = `${pickerID}_badge.png`;
        const url = `api/warehouse/v1/pickers/getBadge?pickerId=${pickerID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok) {
                await fileDownload(res, filename);
            }
        } catch (e) {
            logError(e);
        }
    },
    deleteKnowledgeBaseEntry: (id) => {
        const url = `api/admin/v1/itsKnowledge/${id}/delete`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    deleteRoleFromProfile: (profileID, roleID) => {
        const url = `api/admin/v1/jalaprofiles/${profileID}/${roleID}`;
        return mmFetchWithResponse(url, {
            method: 'DELETE',
        });
    },
    getAccounts: (activeFlag, accountType = '') => {
        let url = `api/admin/v1/jalacounts?active=${activeFlag}`;
        if (accountType) {
            url += `&accountType=${accountType}`;
        }
        return mmFetchWithResponse(url);
    },
    getDiscountFriendFamily: () => {
        const url = `api/admin/v1/discountff`;
        return mmFetchWithResponse(url);
    },
    getKnowledgeBaseEntries: () => {
        const url = `api/admin/v1/itsKnowledge`;
        return mmFetchWithResponse(url);
    },
    getJalapenoProfiles: (activeFlag, accountType) => {
        const url = `api/admin/v1/jalaprofiles?active=${activeFlag}&accountType=${accountType}`;
        return mmFetchWithResponse(url);
    },
    getITSTickets: () => {
        const url = `api/admin/v1/itsTickets`;
        return mmFetchWithResponse(url);
    },
    getPickers: () => {
        const url = `api/warehouse/v1/pickers`;
        return mmFetchWithResponse(url);
    },
    getProfileApprovers: () => {
        const url = `api/admin/v1/jalaprovers`;
        return mmFetchWithResponse(url);
    },
    getProfileRoles: (id) => {
        const url = `api/admin/v1/jalaprofiles/${id}`;
        return mmFetchWithResponse(url);
    },
    getRoles: (accountType) => {
        const url = `api/admin/v1/jalaroles?accountType=${accountType}`;
        return mmFetchWithResponse(url);
    },
    getUserRoles: (id) => {
        const url = `api/admin/v1/jalacounts/${id}`;
        return mmFetchWithResponse(url);
    },
    getUsersWithRole: (roleID) => {
        const url = `api/admin/v1/jalacounts/roles/users?roleID=${roleID}`;
        return mmFetchWithResponse(url);
    },
    sendNetSuitePrompt: (prompt) => {
        const url = `api/netsuitellm/v1/sendprompt`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ prompt }),
        });
    },
    revokeEmployeeBox: (id) => {
        const url = `api/admin/v1/discountff/${id}/revoke`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    searchKnowledgeBase: (params) => {
        let url = `api/admin/v1/itsKnowledge/search`;

        const query = new URLSearchParams();
        if (params.ticketId) {
            query.append('ticketID', params.ticketId);
        }
        if (params.problem) {
            query.append('problem', params.problem);
        }
        const queryString = query.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }

        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    unlinkArticleFromTicket: (id) => {
        const url = `api/admin/v1/itsTickets/${id}/unlink`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    updateAccount: ({ field, id, value }) => {
        const url = `api/admin/v2/jalacounts/user/update`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                id,
                [field]: value,
            }),
        });
    },
    updateEmployeeBox: (id, sendParams) => {
        const url = `api/admin/v1/discountff/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updateITSTicket: (id, item) => {
        const url = `api/admin/v1/itsTickets/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    updateKnowledgeBaseEntry: (id, item) => {
        const url = `api/admin/v1/itsKnowledge/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    updateProfile: (profileID, item) => {
        const url = `api/admin/v1/jalaprofiles/update/${profileID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
};

export { infoTechApi };
